import { FC } from "react";

import { PageContextWrapper, TopHeaderCalendar } from "@ryde/controls";
import { LayoutCrudRoutes, PageClientSideFilters } from "@ryde/layout";
import { RydeUiUnit } from "@ryde/shared";

const entityPage: RydeUiUnit = "incident";

export const IncidentsPage: FC = () => {
  return (
    <PageContextWrapper entity={entityPage}>
      <PageClientSideFilters
        topWidgetComponent={<TopHeaderCalendar entity={entityPage} />}
      />
      <LayoutCrudRoutes />
    </PageContextWrapper>
  );
};
